window.onload = function() {
  if (window.App.templateEvent === "tpl.login") {
    var email = "";

    location.search.replace("?", "").split("&").forEach(function(item) {
      if (item.split("=")[0] === "email") {
        email = item.split("=")[1];

        document.querySelector(".login-pwd-reset input[type='email']").value = email;
        document.querySelector(".login-pwd-reset input[type='email']").dispatchEvent(new Event("input", { bubbles: true }));
      }
    });
  }
}